import AppStoreQrCode from '../../assets/images/appstore/app-store-qr-code.png';
import PlayStoreQrCode from '../../assets/images/playstore/play-store-qr-code.png';
import { DownloadOnAppStoreBanner } from './DownloadOnAppStoreBanner';
import { ConfirmModal } from '../../commons/components/ConfirmModal';
import React from 'react';
import { GetItOnGooglePlayBanner } from './GetItOnGooglePlayBanner';
import { openUrlInNewTab } from '../../util/window-utils';

export const APP_STORE_APP_URL = 'https://apple.co/3Pke4DC';
export const GOOGLE_PLAY_APP_URL =
  'https://play.google.com/store/apps/details?id=com.growegy.growegymobile';

export const DownloadAppModal = (props: { store: 'app-store' | 'play-store' }) => {
  const { store } = props;
  const storeHumanFriendlyName = store === 'app-store' ? 'App Store' : 'Google Play Store';
  return (
    <ConfirmModal
      title={`Download Growegy app on ${storeHumanFriendlyName}`}
      centerTitle={true}
      footer={{ type: 'show' }}
      ariaHideApp={false}
    >
      <div className="download-app-modal__container">
        <div className="text-center">
          <div>Scan this QR code with your mobile phone</div>
          <div>to download the Growegy mobile app:</div>
        </div>
        <img
          src={store === 'app-store' ? AppStoreQrCode : PlayStoreQrCode}
          width={300}
          height={300}
          alt={`Download Growegy app on ${storeHumanFriendlyName}`}
        />
        {store === 'app-store' ? (
          <DownloadOnAppStoreBanner onClick={() => openUrlInNewTab(APP_STORE_APP_URL)} />
        ) : (
          <GetItOnGooglePlayBanner onClick={() => openUrlInNewTab(GOOGLE_PLAY_APP_URL)} />
        )}
      </div>
    </ConfirmModal>
  );
};
